<template>
  <div>
    <v-layout
      v-if="isLoading.general"
      class="loadingQ"
      xs12
      justify-center
      align-content-center
    >
      <!-- <v-progress-circular color="red ligthen-2" style="background-color:transparent; margin:auto" indeterminate :size="150" :width="1" /> -->
      <progress-q></progress-q>
    </v-layout>
    <v-layout
      v-if="!dlc_on"
      class="buy_window"
      xs12
      justify-center
      align-content-center
    >
      <!-- <v-progress-circular color="red ligthen-2" style="background-color:transparent; margin:auto" indeterminate :size="150" :width="1" /> -->
      <div>
        Vuoi offrire la possibilità ai tuoi clienti di utilizzare una fidelity
        card? Acquista il modulo per la creazione e gestione della fidelity
        card. Conquista i tuoi clienti.
      </div>
      <div>Contattaci per acquistare il modulo</div>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 lg3>
        <v-card class="elevation-3 dash-card">
          <v-toolbar
            class="q-orange-bk q-text-whitesmoke elevation-1"
            style="height: 50px"
          >
            <v-toolbar-title style="padding-bottom: 15px">
              <h3>{{ getString("Fidelity Card") }}</h3>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="center">
            <div>
              <h2>
                {{
                  getString("Benvenuto nella tua sezione della Fidelity card")
                }}
              </h2>
              <h3>
                {{ getString("STATO CARTA") + ": " }}
                <b>{{ statoCarta }}</b>
              </h3>
              <img
                src="../../../static/img/dlc/fidelity-card.png"
                class="card"
                style="display: inline-block"
              />
            </div>
            <h3>
              {{
                getString(
                  "Disattivando la carta verrà mostrato un avviso sull'app che la fidelity è temporaneamente non disponibile."
                )
              }}
            </h3>
            <div>
              <v-btn
                class="q-orange-bk q-text-whitesmoke"
                @click="activateCard"
                :disabled="isActive"
                >{{ getString("ATTIVA") }}</v-btn
              >
              <v-btn
                class="q-orange-bk q-text-whitesmoke"
                @click="deactivateCard"
                :disabled="!isActive"
                >{{ getString("DISATTIVA") }}</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 lg5>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{ getString("Regolamento") }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div>
              <p>
                In questa sezione puoi inserire un regolamento (facoltativo) che
                verrà visualizzato all'interno dell'app
              </p>
              <v-flex xs12 class="elevation-3">
                <editor
                  api-key="vn43j4ndioj2ysq09jicr7yfha8fvqcp8kye03mrgsixspv4"
                  v-model="message"
                  :init="{
                    selector: 'textarea',
                    language_url: '../../../static/languages/tinymce/it.js',
                    menubar: false,
                    image_description: false,
                    image_dimensions: false,
                    a11y_advanced_options: true,
                    automatic_uploads: true,
                    file_picker_types: 'image',
                    min_height: 400,
                    branding: false,
                    file_picker_callback: (cb, value, meta) => {},
                  }"
                ></editor>
              </v-flex>
              <div
                :class="{ counter: true, 'counter-red': message.length > 1900 }"
              >
                <h5>{{ countChar }}/2000</h5>
              </div>
            </div>
          </v-card-text>
          <v-progress-linear
            indeterminate
            active
            v-if="loading"
          ></v-progress-linear>
          <v-card-actions>
            <v-btn
              :disabled="loading"
              class="q-orange-bk q-text-whitesmoke"
              @click="saveRules"
              >Salva</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 lg4>
        <v-card class="elevation-3 dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{ getString("Lista premi") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-title>{{
            getString("Inserisci o modifica la lista premi")
          }}</v-card-title>
          <v-card-text>
            <v-layout class="formDesc" row wrap>
              <v-flex xs12 lg6>
                <label>{{ getString("Nome Premio") }}</label>
                <v-text-field
                  v-model="rewardName"
                  :rules="notEmpty"
                  solo
                  :label="getString('Es. Mario')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <label>{{ getString("Punti") }}</label>
                <v-text-field
                  v-model="rewardPoints"
                  :rules="notEmpty"
                  solo
                  :label="getString('Es. 100')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-btn
                  class="q-orange-bk q-text-whitesmoke"
                  @click="addReward"
                  >{{ getString("Aggiungi premio") }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text style="overflow: auto">
            <v-data-table
              :headers="HeadersRewards"
              :items="rewards"
              :rows-per-page-items="[
                10,
                25,
                { text: getString('Tutto'), value: -1 },
              ]"
              :rows-per-page-text="getString('Premi per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="isLoading.rewards"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.points }}</td>
                  <td class="text-xs-center">
                    <v-btn flat @click="removeReward(props.item)">
                      <v-icon>remove_circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12>
        <v-card class="elevation-3 dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Prenotazioni da confermare")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-title>{{
            getString(
              "Di seguito l'elenco di tutte le prenotazioni non ancora confermate. Puoi confermarle qui o direttamente dal calendario."
            )
          }}</v-card-title>
          <v-card-text>
            <v-layout class="formDesc" row wrap style="text-align: center">
              <v-flex xs12 lg6>
                <label>{{ getString("Cerca un cliente") }}</label>
                <v-text-field
                  v-model="searchUser2"
                  solo
                  :label="getString('Mario Rossi')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <label>{{
                  getString("Attenzione: Elimina tutti records in attesa")
                }}</label>
                <v-btn @click="confirmDelete = true">{{
                  getString("Elimina")
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text style="overflow: auto">
            <v-data-table
              :headers="HeadersWaitingPoints"
              :items="filteredWaitingUsers"
              :rows-per-page-items="[10, 25, 50]"
              :rows-per-page-text="getString('Prenotazioni per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="isLoading.waitingUsers"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td style="width: 200px">
                    {{ getDate(props.item.dateAndTime) }}
                  </td>
                  <td style="width: 50px">
                    <v-list-tile-avatar>
                      <img :src="defaultAvatar(props.item.photo)" />
                    </v-list-tile-avatar>
                  </td>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td>
                    <div class="form-btn-no-width">
                      <v-menu offset-y>
                        <v-btn
                          class="q-orange-bk q-text-whitesmoke"
                          slot="activator"
                          >{{ getString("Seleziona") }}</v-btn
                        >
                        <v-list-tile style="background: white">
                          <v-btn flat @click="updateScore(props.item, 10)"
                            >10</v-btn
                          >
                          <v-btn flat @click="updateScore(props.item, 20)"
                            >20</v-btn
                          >
                          <v-btn flat @click="updateScore(props.item, 30)"
                            >30</v-btn
                          >
                          <v-btn
                            flat
                            @click="
                              () => {
                                showAltro = true;
                              }
                            "
                            >altro</v-btn
                          >
                        </v-list-tile>
                      </v-menu>
                      <div class="form-btn-no-width" v-show="showAltro">
                        <v-text-field
                          hint="Inserisci i punti che vuoi dare"
                          label="Punti"
                          solo
                          v-model="props.item.selectedPoints"
                          style="width: 150px"
                        ></v-text-field>
                        <v-icon
                          class="icon-black"
                          @click="
                            updateScore(props.item, props.item.selectedPoints)
                          "
                          >save</v-icon
                        >
                      </div>
                      <v-btn @click="removeScore(props.item)">{{
                        getString("Elimina")
                      }}</v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 lg12>
        <v-card class="elevation-3 dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{ getString("Elenco tessere") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <p>
              {{
                getString(
                  "Vedi l'elenco di tutte le carte fedeltà dei tuoi clienti"
                )
              }}
            </p>
            <p>
              {{
                getString(
                  "Da questa sezione puoi vedere i punti di ogni tessera, aumentare o diminuire manualmente i punti di ogni tessera o riscattare un eventuale premio"
                )
              }}
            </p>
          </v-card-title>
          <v-card-text>
            <v-layout class="formDesc" row wrap>
              <v-flex xs12 lg6>
                <label>{{ getString("Nome cliente") }}</label>
                <v-text-field
                  v-model="searchUser"
                  solo
                  :label="getString('es. Mario Esposito')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text style="overflow: auto">
            <v-data-table
              :headers="HeadersScore"
              :items="filteredScores"
              :rows-per-page-items="[
                10,
                25,
                { text: getString('Tutto'), value: -1 },
              ]"
              :rows-per-page-text="getString('Utenti per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="isLoading.score"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.position }}</td>
                  <td>
                    <v-list-tile-avatar>
                      <img :src="defaultAvatar(props.item.photo)" />
                    </v-list-tile-avatar>
                  </td>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.points }}</td>
                  <td style="padding-top: 20px">
                    <div class="form-btn">
                      <v-text-field
                        v-model="props.item.add"
                        solo
                        :label="getString('Es. 100')"
                      ></v-text-field>
                      <v-icon class="icon-black" @click="saveScore(props.item)"
                        >save</v-icon
                      >
                    </div>
                  </td>
                  <td style="padding-top: 20px">
                    <div class="form-btn" style="width: 250px">
                      <v-text-field
                        v-model="props.item.cardCode"
                        solo
                        :label="getString('Codice carta')"
                        :hint="
                          getString(
                            'Inserisci il codice della carta fisica se ne utilizzi una.'
                          )
                        "
                      ></v-text-field>
                      <v-icon class="icon-black" @click="saveCod(props.item)"
                        >save</v-icon
                      >
                    </div>
                  </td>
                  <td>
                    <v-menu offset-y>
                      <v-btn
                        class="q-orange-bk q-text-whitesmoke"
                        slot="activator"
                        >{{ getString("Seleziona premio") }}</v-btn
                      >
                      <v-list-tile
                        style="background: white"
                        v-for="(item, index) in rewards"
                        :key="index"
                        @click="rewardScore(props.item, item)"
                      >
                        <v-btn flat>{{ item.name }}</v-btn>
                      </v-list-tile>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12>
        <v-card class="elevation-3 dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{ getString("Cronologia") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-title>{{
            getString("Verifica le vincite degli utenti")
          }}</v-card-title>
          <v-card-text>
            <v-layout class="formDesc" row wrap>
              <v-flex xs12 lg6>
                <label>{{ getString("Nome da cercare") }}</label>
                <v-text-field
                  v-model="searchUser1"
                  :rules="notEmpty"
                  solo
                  :label="getString('Es. Premi')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text style="overflow: auto">
            <v-data-table
              :headers="HeadersHistory"
              :items="filteredHistory"
              :rows-per-page-items="[
                10,
                25,
                { text: getString('Tutto'), value: -1 },
              ]"
              :rows-per-page-text="getString('Righe per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="isLoading.history"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    <v-list-tile-avatar>
                      <img :src="defaultAvatar(props.item.photo)" />
                    </v-list-tile-avatar>
                  </td>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">
                    {{
                      props.item.hasReward
                        ? props.item.points * -1
                        : props.item.points
                    }}
                  </td>
                  <td class="text-xs-left">{{ props.item.currentPoints }}</td>
                  <td class="text-xs-left">{{ props.item.reward }}</td>
                  <td class="text-xs-left">
                    {{ getDate(props.item.created) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <modal v-show="confirmDelete" @click="confirmDelete = false">
        <v-card-title class="no-padding" slot="header">
          <v-toolbar color="red darken-2" style="text-align: center">
            <span class="headline q-text-whitesmoke text-center">{{
              getString("Conferma eliminazione")
            }}</span>
          </v-toolbar>
        </v-card-title>
        <v-card-text slot="body">
          <v-layout wrap>
            <p>
              {{
                getString(
                  "Sei sicuro di voler procedere? L'operazione è irreversibile."
                )
              }}
            </p>
          </v-layout>
        </v-card-text>
        <v-card-actions slot="footer">
          <v-btn
            class="q-orange"
            flat
            @click.native="confirmDelete = false"
            >{{ getString("No") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="q-orange-bk q-text-whitesmoke"
            @click.native="removeAllScore"
            >{{ getString("Conferma") }}</v-btn
          >
        </v-card-actions>
      </modal>
  </div>
</template>

<script>
import ajax from "../../ajax.js";
import moment from "moment";
import Utils from "./../../utils";
import Editor from "@tinymce/tinymce-vue";
import ProgressQ from "./ProgressQ";
import Modal from "../utils/Modal";
var ut = new Utils();

export default {
  name: "Fidelity",
  components: {
    editor: Editor,
    ProgressQ,
    Modal
  },
  mounted: function () {
    // Se l'utente ha la dlc attivata o sei un admin
    if (this.hasDlc || this.isAdmin) {
      //isadmin è necessario perchè con il fakeuser non vedo le dlc attivate per quell'utente
      this.dlc_on = true;
      this.cardState();
      this.getRewards();
      this.getScores();
      this.getHistory();
      this.getWaitingUsers();
    }
  },
  computed: {
    shopID: function () {
      if (this.$store.state.userShops.length > 0)
        return this.$store.state.userShops[0].idBarberShop;
      return 0;
    },
    countChar: function () {
      return (
        this.getString("Caratteri: ") + this.stripHtml(this.message).length
      );
    },
    HeadersRewards: function () {
      let result = [];
      let self = this;

      let temp = [self.getString("Premio"), self.getString("Punti")];
      temp.forEach((element) => {
        result.push({
          text: self.getString(element.split(":")[0]),
          align: "left",
          sortable: element.split(":").length > 1,
          value: element.split(":")[1],
        });
      });
      result.push({
        text: self.getString("Azione"),
        align: "center",
        sortable: false,
      });
      return result;
    },
    HeadersWaitingPoints: function () {
      let result = [];
      let self = this;

      let temp = [
        self.getString("Data prenotazione") + ":dateAndTime",
        self.getString("Foto"),
        self.getString("Nome") + ":name",
        self.getString("Conferma punti"),
      ];
      temp.forEach((element) => {
        result.push({
          text: self.getString(element.split(":")[0]),
          align: "left",
          sortable: element.split(":").length > 1,
          value: element.split(":")[1],
        });
      });
      return result;
    },
    HeadersScore: function () {
      let result = [];
      let self = this;

      let temp = [
        self.getString("Pos.") + ":position",
        self.getString("Foto"),
        self.getString("Nome") + ":name",
        self.getString("Punti") + ":points",
        self.getString("Aggiungi"),
        self.getString("Codice carta"),
        self.getString("Dai Premio"),
      ];
      temp.forEach((element) => {
        result.push({
          text: self.getString(element.split(":")[0]),
          align: "left",
          sortable: element.split(":").length > 1,
          value: element.split(":")[1],
        });
      });
      return result;
    },
    HeadersHistory: function () {
      let result = [];
      let self = this;

      let temp = [
        self.getString("Foto"),
        self.getString("Nome"),
        self.getString("Differenza"),
        self.getString("Saldo"),
        self.getString("Premio"),
        self.getString("Data"),
      ];
      temp.forEach((element) => {
        result.push({
          text: self.getString(element.split(":")[0]),
          align: "left",
          sortable: element.split(":").length > 1,
          value: element.split(":")[1],
        });
      });
      return result;
    },
    hasDlc: {
      get: function () {
        return this.$store.getters.hasDlc("D0");
      },
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin;
    },
    isFree: function () {
      return this.$store.getters.hasDlc("V10");
    },
    statoCarta: function () {
      return this.isActive
        ? this.getString("ATTIVA")
        : this.getString("DISATTIVATA");
    },
    maxSort: function () {
      let max = 0;
      this.prices.forEach((element) => {
        if (element.sort > max) max = element.sort;
      });
      return max;
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    sortOptions: function () {
      return {
        handle: ".handle",
      };
    },
    validInput: function () {
      try {
        return this.rewardName !== "" && Number.parseInt(this.rewardPoints) > 0;
      } catch (err) {
        return false;
      }
    },
    filteredScores: function () {
      if (this.searchUser === "" || this.searchUser === null)
        return this.scores;
      return this.scores.filter((x) =>
        x.name.toLowerCase().includes(this.searchUser.toLowerCase())
      );
    },
    filteredWaitingUsers: function () {
      if (this.searchUser2 === "" || this.searchUser2 === null)
        return this.waitingUsers;
      return this.waitingUsers.filter((x) =>
        x.name.toLowerCase().includes(this.searchUser2.toLowerCase())
      );
    },
    filteredHistory: function () {
      if (this.searchUser1 === "" || this.searchUser1 === null)
        return this.history;
      return this.history.filter((x) =>
        x.name.toLowerCase().includes(this.searchUser1.toLowerCase())
      );
    },
  },
  data: () => {
    return {
      isLoading: {
        general: false,
        waitingUsers: false,
        rewards: false,
        score: false,
        history: false,
      },
      message: "",
      dlc_on: false,
      isActive: false,
      rewardName: "",
      rewardPoints: "1",
      rewards: [],
      scores: [],
      searchUser: "",
      searchUser1: "",
      searchUser2: "",
      history: [],
      waitingUsers: [],
      showAltro: false,
      confirmDelete: false,
    };
  },
  methods: {
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html;
      // Retrieve the text property of the element (cross-browser support)
      return (
        temporalDivElement.textContent || temporalDivElement.innerText || ""
      );
    },
    getDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    saveRules: function () {
      let self = this;
      self.isLoading.general = true;
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/fid/rules",
          {
            rules: self.message,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          self.$emit("siteAlertSuccess", response.data.data);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.general = false;
        });
    },
    addReward: function () {
      let self = this;
      self.isLoading.general = true;
      if (!this.validInput) {
        this.$emit("siteAlert", this.getString("Valori non validi"));
        return;
      }
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/fid/reward",
          {
            name: self.rewardName,
            points: self.rewardPoints,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          self.$emit("siteAlertSuccess", response.data.data);
          self.getRewards();
          self.rewardName = "";
          self.rewardPoints = "1";
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.general = false;
        });
    },
    removeReward: function (item) {
      let self = this;
      self.isLoading.general = true;
      ajax.axios
        .delete(ajax.baseUrl() + "/admin/fid/reward/" + item.idReward, {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          self.$emit("siteAlertSuccess", response.data.data);
          self.getRewards();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.general = false;
        });
    },
    getRewards: function () {
      let self = this;
      self.isLoading.rewards = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/fid/reward", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          self.rewards = response.data.data;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.rewards = false;
        });
    },
    getScores: function () {
      let self = this;
      self.isLoading.score = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/fid/score", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          let temp = response.data.data;
          for (let index = 0; index < temp.length; index++) {
            temp[index]["position"] = index + 1;
            temp[index]["add"] = 0;
          }
          self.scores = temp;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.score = false;
        });
    },
    getWaitingUsers: function () {
      let self = this;
      self.isLoading.waitingUsers = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/fid/waitingUsers", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          let temp = response.data.data;
          self.waitingUsers = temp;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.general = false;
          self.isLoading.waitingUsers = false;
        });
    },
    getHistory: function () {
      let self = this;
      self.isLoading.history = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/fid/history", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          let temp = response.data.data;
          self.history = temp;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.history = false;
        });
    },
    getString: function (key, values) {
      return this.$store.state.currentTranslator.getString(key, values);
    },
    activateCard: function () {
      let self = this;
      self.isLoading.general = true;
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/fid/activate",
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          self.$emit("siteAlertSuccess", response.data.data);
          self.cardState();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.general = false;
        });
    },
    deactivateCard: function () {
      let self = this;
      self.isLoading.general = true;
      ajax.axios
        .delete(ajax.baseUrl() + "/admin/fid/activate", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          self.$emit("siteAlertSuccess", response.data.data);
          self.cardState();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.isLoading.general = false;
        });
    },
    defaultAvatar: function (url) {
      if (
        url === null ||
        url === "images/u_placeholder.jpg" ||
        url === "/images/u_placeholder.jpg"
      ) {
        return "/../../../../static/img/default-avatar.png";
      } else return ajax.baseUrl() + url;
    },
    updateScore: function (item, points) {
      try {
        var self = this;
        var a = Number.parseInt(points);
        if (!Number.isInteger(a)) {
          this.$emit("siteAlert", "Numero non valido");
          return;
        }
        var newPoints = Number.parseInt(points);
        self.isLoading.general = true;
        ajax.axios
          .put(
            ajax.baseUrl() +
              "/admin/fid/reservation/" +
              item.referenceReservation +
              "/add/" +
              newPoints,
            {},
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            self.$emit("siteAlertSuccess", "Aggiornato");
            self.getScores();
            self.getHistory();
            self.getWaitingUsers();
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    removeAllScore: function () {
      this.confirmDelete = false;
      try {
        var self = this;
        self.isLoading.general = true;
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/fid/shop/" +
              self.shopID +
              "/history/",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            self.$emit("siteAlertSuccess", "Tutti i records eliminati");
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(function () {
            
            self.getWaitingUsers();
          });
      } catch (error) {
        console.log(error);
      }
    },
    removeScore: function (item) {
      try {
        var self = this;
        self.isLoading.general = true;
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/fid/shop/" +
              self.shopID +
              "/history/" +
              item.id,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            self.$emit("siteAlertSuccess", "Rimosso con successo");
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(function () {
            self.getWaitingUsers();
          });
      } catch (error) {
        console.log(error);
      }
    },
    saveScore: function (item) {
      try {
        var self = this;
        var a = Number.parseInt(item.add);
        if (!Number.isInteger(a) || a === 0) {
          self.$emit("siteAlert", "Numero non valido");
        } else {
          var newPoints = Number.parseInt(item.add);
          self.isLoading.general = true;
          ajax.axios
            .put(
              ajax.baseUrl() +
                "/admin/fid/score/" +
                item.id +
                "/add/" +
                newPoints,
              {},
              {
                headers: self.$store.getters.tokenHeader,
                withCredentials: true,
              }
            )
            .then(function (response) {
              self.$emit("siteAlertSuccess", "Aggiornato");
            })
            .catch(function (error) {
              var auth = ajax.checkAuth(error, self.$store, self.$router);
              self.$emit(
                "siteAlert",
                auth
                  ? self.getString("Non hai l'autorizzazione")
                  : error.response.data.errorMessage
              );
            })
            .finally(function () {
              self.getScores();
              self.getHistory();
              self.isLoading.general = false;
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
    saveCod: function (item) {
      try {
        var self = this;
        self.isLoading.general = true;
        var cardCode = "";
        if (item.cardCode !== undefined) cardCode = item.cardCode;

        var json = { code: cardCode };
        ajax.axios
          .put(ajax.baseUrl() + "/admin/fid/score/" + item.id + "/cod", json, {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          })
          .then(function (response) {
            self.$emit("siteAlertSuccess", "Aggiornato");
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(function () {
            self.getScores();
            self.isLoading.general = false;
          });
      } catch (error) {
        console.log(error);
      }
    },
    rewardScore: function (item, subtract) {
      try {
        var self = this;
        self.isLoading.general = true;
        var newPoints =
          Number.parseInt(item.points) - Number.parseInt(subtract.points);
        console.log(newPoints);
        ajax.axios
          .put(
            ajax.baseUrl() +
              "/admin/fid/score/" +
              item.id +
              "/reward/" +
              subtract.idReward,
            {},
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            self.$emit("siteAlertSuccess", "Aggiornato");
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(function () {
            self.getScores();
            self.getHistory();
            self.isLoading.general = false;
          });
      } catch (error) {}
    },
    cardState: function () {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/fid/card", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          const card = response.data.data;
          self.isActive = !card.disabled;
          self.message = card.rules;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}

.card {
  width: 300px;
}

.loadingQ {
  z-index: 100;
  position: fixed;
  width: 100%;
  height: 100%;
  display: grid;
  background: #50555645;
  margin: auto;
}

.buy_window {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #727170b0;
  z-index: 5;
  display: block;
}

.buy_window div {
  background: var(--background-color);
  padding: 40px;
  font-size: 30px;
  margin: 50px;
}

.icon-black {
  color: black;
}

.form-btn {
  display: flex;
  width: 100px;
}
.form-btn-no-width {
  display: flex;
}
.form-btn-no-width i {
  padding: 10px;
  align-items: flex-start;
}

.form-btn i {
  padding: 10px;
  align-items: flex-start;
}

.center {
  text-align: center;
}

.counter {
  text-align: right;
  margin-top: 10px;
  color: #666;
  transition: color linear 0.3s;
}

.counter-red {
  color: tomato;
}
.border {
  border: 2px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Fidelity.vue